import { render, staticRenderFns } from "./FinanceRatio.vue?vue&type=template&id=704b9842&scoped=true&"
import script from "./FinanceRatio.vue?vue&type=script&lang=js&"
export * from "./FinanceRatio.vue?vue&type=script&lang=js&"
import style0 from "./FinanceRatio.vue?vue&type=style&index=0&id=704b9842&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b9842",
  null
  
)

export default component.exports